import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import ActivityLogView from "../components/activity-log/ActivityLogView";

const ActivityLog = () => {
  return (
    <AdminLayout>
      <ActivityLogView />
    </AdminLayout>
  );
};

export default ActivityLog;
